/**
 * useOnboarding — Hook to access onboarding context
 */

import { useContext } from 'react';
import { OnboardingContext } from './OnboardingProvider';
import type { OnboardingContextValue } from './types';

export function useOnboarding(): OnboardingContextValue {
  const context = useContext(OnboardingContext);
  if (!context) {
    return {
      startTour: () => {},
      endTour: () => {},
      hasCompletedTour: () => false,
      hasStartedTour: () => false,
      resetAllTours: () => {},
      isActive: false,
      currentTour: null,
      setTourEventHandler: () => {},
      getStopPoints: () => [],
    };
  }
  return context;
}
